<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Still Life: A Novel</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1"><a id="page1"></a><a href="#/contents#toc_3" id="con_3"><i>PART ONE</i></a></p>
<p class="line"></p>
<p class="ct2"><a href="#/contents#toc_3"><b>THE WRECKAGE</b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?65bbf278